module.exports = __webpack_public_path__ + "static/media/IMG_1527.3c53c83a.JPG";